import User from '../models/User';

const USERPILOT_TOKEN = process.env.REACT_APP_USERPILOT_TOKEN;
const SDK_SRC = "https://js.userpilot.io/sdk/latest.js";

function getLocaleCode(user: User) {
    const i18nextLanguage = localStorage.getItem('i18nextLng');
    const storedLanguage = localStorage.getItem('language');
    const userLanguage = (user.language as any)?.encodedName || (user.language as any)?.code;

    return i18nextLanguage || storedLanguage || userLanguage || 'es';
}

export function initUserpilot() {
    if (!USERPILOT_TOKEN) return;

    if ((window as any).__userpilot_inited) return;
    (window as any).__userpilot_inited = true;

    (window as any).userpilotSettings = { token: USERPILOT_TOKEN };

    const s = document.createElement("script");
    s.async = true;
    s.src = SDK_SRC;

    s.onload = () => {
        // Notify the app that the SDK is available (useful for delayed identify in SPA boot).
        window.dispatchEvent(new Event('userpilot:ready'));
    };

    document.head.appendChild(s);
}

export function identifyUserpilot(user: User) {
    const userpilot = (window as any).userpilot;
    if (!userpilot || !user) return false;

    const distinctId = user.userId ?? String(user.id);
    const localeCode = getLocaleCode(user);

    userpilot.identify(distinctId, {
        email: user.email,
        name: `${user.name}${user.lastName ? " " + user.lastName : ""}`,
        role: (user.role as any)?.name ?? (user.role as any)?.code ?? String(user.role),
        createdAt: user.AccountCreatedDT ? new Date(user.AccountCreatedDT).toISOString() : undefined,

        country: (user.country as any)?.name ?? (user.country as any)?.code,
        locale_code: localeCode,
        language: localeCode,
        regions: user.regions?.map(r => (r as any)?.name ?? (r as any)?.code),

        hasAccessToContentManagement: user.hasAccessToContentManagement ?? false,
        displayMyPortfolio: user.displayMyPortfolio ?? false,
    });

    userpilot.reload?.();
    return true;
}

export function reloadUserpilot() {
    (window as any).userpilot?.reload?.();
}

export function trackUserpilotEvent(
    eventName: string,
    properties: Record<string, string | number | boolean>,
) {
    try {
        const userpilot = (window as any).userpilot;
        if (typeof userpilot?.track !== 'function') return;

        userpilot.track(eventName, properties);
    } catch {
        // Analytics failures must not interrupt the user's operation.
    }
}

export function endUserpilotFlow() {
    (window as any).userpilot?.end?.();
}
